import { render } from "./FoldseekSearchResult.vue?vue&type=template&id=3c0dbd86"
import script from "./FoldseekSearchResult.vue?vue&type=script&lang=js"
export * from "./FoldseekSearchResult.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__